<template>
  <div id="body">
    <!--[if lt IE 7]>
    <p class="browsehappy">You are using an <strong>outdated</strong> browser. Please <a href="http://browsehappy.com/">upgrade
      your browser</a> to improve your experience.</p>
    <![endif]-->

    <!-- Header area -->
    <header id="header" style="position: relative">
      <vue-particles
        color="#fff"
        :particleOpacity="0.7"
        :particlesNumber="60"
        shapeType="circle"
        :particleSize="4"
        linesColor="#dedede"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.6"
        :linesDistance="200"
        :moveSpeed="6"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
      >
      </vue-particles>
      <div style="position: absolute;top:40%;width: 100%">
        <div class="center text-center">
          <h2 class="" style="font-size: 4rem;
    font-family: Teko,sans-serif;
    text-shadow: 8px 8px #000;
    text-transform: uppercase;
    margin: 0;">{{strings_read==0?'':this.strings.main_titles.text}}</h2>
          <h3 class="">{{strings_read==0?'':this.strings.main_titles1.text}}</h3>
        </div>
      </div>

      <div class="bottom">
        <a data-scroll href="#navigation" class="scrollDown animated pulse" id="scrollToContent"><i
          class="pe-7s-angle-down-circle pe-va"></i></a>
      </div>
    </header>

    <!-- Navigation area -->
    <section id="navigation">
      <div class="container">
        <div class="row">
          <div class="col-xs-6">
            <div class="logo"><a data-scroll href="#body" class="logo-text">{{strings_read==0?'':this.strings.logo_text.text}}</a>
            </div>
          </div>
          <div class="col-xs-6">
            <div class="nav">
              <a href="#" data-placement="bottom" title="Menu" class="menu" data-toggle="dropdown"><i
                class="pe-7s-menu"></i></a>
              <div class="dropdown-menu">
                <div class="arrow-up"></div>
                <ul>
                  <li><a data-scroll href="#body">Home <i class="pe-7s-home"></i></a><span class="menu-effect"></span>
                  </li>
                  <li><a data-scroll href="#services">Service <i class="pe-7s-config"></i></a><span
                    class="menu-effect"></span></li>
                  <li><a data-scroll href="#portfolio">Portfolio <i class="pe-7s-glasses"></i></a><span
                    class="menu-effect"></span></li>
                  <li><a data-scroll href="#testimonial">Testimonial <i class="pe-7s-comment"></i><span
                    class="menu-effect"></span></a></li>
                  <li><a data-scroll href="#contact">Contact <i class="pe-7s-help1"></i></a><span
                    class="menu-effect"></span></li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <!-- Content Area -->

    <!-- services section -->

    <section id="services" class="service-area">
      <div class="container">
        <h2 class="block_title">{{strings_read==0?'':this.strings.title1.text}}</h2>
        <div class="row">
          <div class="col-md-3 col-sm-6" v-for="item in this.services" v-bind:key="item.uid">
            <div class="services">
              <div class="service-wrap" style="padding-top: 25px">
                <img :src="item.icon" width="50" height="50">
                <h3>{{item.title}}</h3>
                <p>{{item.description}}</p>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section><!-- services -->

    <!-- Portfolio Area -->

    <section id="portfolio" class="portfolio-area">
      <div class="container">
        <h2 class="block_title">{{strings_read==0?'':this.strings.title2.text}}</h2>
        <div class="row port cs-style-3" v-if="works_read==1">
          <div class="col-md-4 col-sm-6 col-xs-12 item-space" v-for="item in works" :key="item.uid"
               style="height: 250px">
            <figure style="height: 100%">
              <div :style="{'background-image': 'url('+item.imgs[0]+')'}"
                   style="width: 100%;height: 100%;background-size: cover;background-position: center"></div>
              <!--<img :src="item.imgs[0]" alt="img04">-->
              <figcaption>
                <span style="float: right">{{item.developer}}</span>
                <h3>{{item.title}} </h3>
                <p style="color: white">{{item.detail}}</p>
                <a :href="item.link.web == '' ? item.link.app : item.link.web" class="button" target="_blank">view</a>
              </figcaption>
            </figure>
          </div>
          <!--<div class="col-xs-12">
            <div class="btn-center"><a href="#" class="big button">View all</a></div>
          </div>-->
        </div>
      </div><!-- container -->
    </section><!-- portfolio -->

    <!-- Testimonial Area -->

    <section id="testimonial" class="testimonial-area">
      <div class="container">
        <h2 class="block_title">{{strings_read==0?'':this.strings.title3.text}}</h2>
        <div class="row">
          <div class="col-xs-12">
          </div>
          <div id="testimonial-container" class="col-xs-12">
            <vueper-slides
              3d fixed-height="300px" arrows-outside bullets-outside alwaysRefreshClones
            >
              <vueper-slide
                v-for="item in profiles"
                :key="item.uid"
              >
                <template v-slot:content>
                  <div class="testimonila-block">
                    <img :src="item.img" alt="clients" class="selfshot">
                    <h3>{{item.name}}</h3>
                    <h5>{{item.role}}</h5>
                    <p>{{item.description}}</p>
                  </div>
                </template>
              </vueper-slide>
            </vueper-slides>
          </div>
        </div>
      </div><!-- container -->
    </section><!-- testimonial -->

    <!-- Contact Area -->

    <section id="contact" class="mapWrap">
      <!-- <div id="googleMap" style="width:100%;"></div>-->
      <div id="contact-area">
        <div class="container">
          <h2 class="block_title">{{strings_read==0?'':this.strings.title4.text}}</h2>
          <div class="row">
            <div class="col-xs-12">
            </div>
            <div class="col-sm-6">
              <div class="moreDetails">
                <h2 class="con-title">{{strings_read==0?'':this.strings.sub_title1.text}}</h2>
                <p> {{strings_read==0?'':this.strings.about_us.text}} </p>
                <ul class="address">
                  <li><i class="pe-7s-map-marker"></i><span>{{strings_read==0?'':this.strings.address.text}}</span>
                  </li>
                  <li><i class="pe-7s-mail"></i>
                    <span>Email: {{strings_read==0?'':this.strings.email.text}}</span><br>
                    <span>Skype: {{strings_read==0?'':this.strings.skype.text}}</span>
                  </li>
                  <li><i class="pe-7s-phone"></i><span>{{strings_read==0?'':this.strings.phoneNumber.text}}</span></li>
                  <!--<li><i class="pe-7s-global"></i><span><a href="#">{{strings_read==0?"":this.strings.phoneNumber.text}}</a></span></li>-->
                </ul>
              </div>
            </div>
            <div class="col-sm-6">
              <h2 class="con-title">{{strings_read==0?'':this.strings.sub_title2.text}}</h2>
              <form role="form" @submit.prevent="sendEmail">
                <div class="form-group">
                  <input type="text" class="form-control" id="user_name" name="user_name" placeholder="Enter your name">
                </div>
                <div class="form-group">
                  <input type="email" name="user_email" class="form-control" id="user_email"
                         placeholder="Enter your email">
                </div>
                <div class="form-group">
                  <textarea name="message" id="message" class="form-control" rows="5" required></textarea>
                </div>
                <div v-if="mail_sent_error!=''" style="background-color: #4cae4c55">
                  {{this.mail_sent_error}}
                </div>
                <button type="submit" class="btn medium">Submit</button>
              </form>
            </div>
          </div>
        </div><!-- container -->
      </div><!-- contact-area -->
      <!--<div id="social">
        <div class="container">
          <div class="row">
            <div class="col-xs-12">
              <ul class="scoialinks">
                <li class="normal-txt">Find me on</li>
                <li class="social-icons"><a class="facebook" href="#"></a></li>
                <li class="social-icons"><a class="twitter" href="#"></a></li>
                <li class="social-icons"><a class="linkedin" href="#"></a></li>
                <li class="social-icons"><a class="google-plus" href="#"></a></li>
                <li class="social-icons"><a class="wordpress" href="#"></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>&lt;!&ndash; social &ndash;&gt;-->
    </section><!-- contact -->

    <!-- Footer Area -->

    <footer>
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <p class="copyright">{{strings_read==0?'':this.strings.footer.copyright}} <a href="#" target="_blank">{{strings_read==0?'':this.strings.footer.site_name}}</a>
            </p>
          </div>
          <div class="col-sm-6">
            <p class="designed">{{strings_read==0?'':this.strings.footer.description}}</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import firebase from 'firebase'
  import {VueperSlide, VueperSlides} from 'vueperslides'
  import 'vueperslides/dist/vueperslides.css'
  import emailjs from 'emailjs-com'

  export default {
    name: 'Home',
    components: {VueperSlides, VueperSlide},
    data () {
      return {
        msg: 'Welcome to Your Vue.js App',
        strings: {},
        services: [],
        works: [],
        profiles: [],
        strings_read: 0,
        works_read: 0,
        mail_sent_error:''
      }
    },
    created () {
      this.read()
    },
    methods: {
      sendEmail (e) {
        console.log(e.target.user_name.value)
        /*emailjs.sendForm('gmail', 'template_Zkxoxc3y', e.target, 'user_C5PxH8I3QYUQI7f06JLSY')
          .then((result) => {
            console.log('SUCCESS!', result.status, result.text)
          }, (error) => {
            console.log('FAILED...', error)
          })*/
        var product_url = 'https://us-central1-tolrenfrank2020.cloudfunctions.net/sendMail?user_email=' + e.target.user_email.value + '&user_name=' + e.target.user_name.value + '&message=' + e.target.message.value
        axios.get(product_url).then(({data}) => {
          if (data.msg=='sent'){
            this.mail_sent_error='We will response as soon as possible.'
          }else{
            this.mail_sent_error='Please submit again kindly.'
          }
          console.log('SUCCESS!', data)
        }).catch(function (resp) {
          //console.log(resp);
          console.log('FAILED...', resp)
        })
      },
      read () {
        let db = firebase.firestore().collection('strings')
        db.onSnapshot(doc => {
          if (doc.empty) {
            this.error = 'There is no any strings'
            return
          }
          this.strings = {}
          doc.forEach(item => {
            var text = item.data()
            this.strings[item.id] = text
            // console.log('strings', item.data())
          })
          // console.log('strings', this.strings)
          this.strings_read = 1
        })

        // eslint-disable-next-line camelcase
        let db_services = firebase.firestore().collection('services')
        db_services.where('state', '==', true).orderBy('order', 'desc').onSnapshot(doc => {
          if (doc.empty) {
            this.error = 'There is no any strings'
            return
          }
          this.services = []
          doc.forEach(item => {
            var text = item.data()
            text.uid = item.data().id
            this.services.unshift(text)
            // this.strings[text.uid] = text.data[text.uid]
            // console.log('strings', text.uid)
          })
        })
        // eslint-disable-next-line camelcase
        let db_works = firebase.firestore().collection('works')
        db_works.where('state', '==', true).orderBy('order', 'desc').onSnapshot(doc => {
          if (doc.empty) {
            this.error = 'There is no any strings'
            return
          }
          this.works = []
          doc.forEach(item => {
            var text = item.data()
            text.uid = item.data().id
            this.works.unshift(text)
            // this.strings[text.uid] = text.data[text.uid]
            // console.log('works reading', works)
          })
          console.log('works reading', this.works)
          this.works_read = 1
        })
        // eslint-disable-next-line camelcase
        let db_profiles = firebase.firestore().collection('profiles')
        db_profiles.where('state', '==', true).orderBy('order', 'desc').onSnapshot(doc => {
          if (doc.empty) {
            this.error = 'There is no any strings'
            return
          }
          this.profiles = []
          doc.forEach(item => {
            var text = item.data()
            text.uid = item.data().id
            this.profiles.unshift(text)
            // this.strings[text.uid] = text.data[text.uid]
            // console.log('strings', text.uid)
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue